<template>
  <div class="general-indicators-general-section">
    <overview-section
      v-if="canViewAbonentsStatistics"
      :abonents-statistics="abonentsStatistics"
      :loading-abonents-statistics="loadingAbonentsStatistics"
      :can-view-abonents-statistics="canViewAbonentsStatistics"
    />

    <agents-section
      v-if="canViewGeneralIndicators"
      :class="{ 'general-indicators-general-section__agents': canViewAbonentsStatistics }"
      :array-agents="arrayAgents"
      :array-managements="arrayManagements"
      :headers="headers"
      :object-total="objectTotal"
      :display-loading-indicators="displayLoadingIndicators"
      :display-loading="displayLoading"
      :title-display="titleDisplay"
    />
  </div>
</template>

<script>
import OverviewSection from '@/components/reports/GeneralIndicatorsOverviewSection';
import AgentsSection from '@/components/reports/GeneralIndicatorsAgentsSection';

export default {
  name: 'GeneralIndicatorsGeneralSection',
  components: {
    OverviewSection,
    AgentsSection,
  },
  props: {
    abonentsStatistics: {
      type: Object,
      required: true,
    },
    loadingAbonentsStatistics: {
      type: Boolean,
      default: false,
    },
    canViewAbonentsStatistics: {
      type: Boolean,
      default: false,
    },
    canViewGeneralIndicators: {
      type: Boolean,
      default: false,
    },
    arrayAgents: {
      type: Array,
      default: () => [],
    },
    arrayManagements: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    objectTotal: {
      type: Object,
      default: () => ({}),
    },
    displayLoadingIndicators: {
      type: Boolean,
      default: false,
    },
    displayLoading: {
      type: Boolean,
      default: false,
    },
    titleDisplay: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.general-indicators-general-section__agents {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
